// productPage JS, for page template in datarobot6 theme 
// datarobot6/views/templates/product-page.twig 

document.addEventListener('DOMContentLoaded', function() {
    var siteHeader = document.querySelector('.siteHeader__navigation'); // fixed nav
    var heroSection = document.querySelector('.productPage__hero'); // hero section
    var productPageContainers = document.querySelectorAll('.productPage__container'); // content sections
    var siteMainContent = document.querySelector('.siteMain'); // main page container
    var productPageContent = document.querySelector('.productPage__content'); // main content container
    var headerHeight = siteHeader ? siteHeader.offsetHeight : 0; // get height of the nav
    var sectionPadding = 4 * 16; // 4rem converted to px (1rem = 16px)
    var isSidebarFixed = false; // track if the sidebar is currently fixed
    var sidebarLinks = []; // keep track of sidebar links
    var isManualScroll = false; // handle scroll-triggered active state
    var isMenuOpen = false; // track the mobile menu state

    var productPageHeadings = document.querySelectorAll('.productPage__heading');
    var mainContent = document.querySelector('.productPage__main');
    
    // Check if there are NO productPage__heading elements
    if (productPageHeadings.length > 0 && mainContent) {
        mainContent.classList.add('-sidebarPresent');
    }

    // Continue with sidebar creation if productPage__heading elements exist
    if (productPageHeadings.length > 0 && productPageContent) {

        var sidebar = document.createElement('div');
        sidebar.classList.add('productPage__sidebar');

        var sidebarInner = document.createElement('div');
        sidebarInner.classList.add('productPage__sidebarMenu');

        // Create toggle button for mobile menu
        var sidebarToggle = document.createElement('div');
        sidebarToggle.classList.add('productPage__sidebarMenuToggle');
        sidebarToggle.classList.remove('-open');
        sidebar.appendChild(sidebarToggle);

        // Iterate over each productPage__container and create sidebar links
        productPageContainers.forEach(function(productPageContainer, index) {
            var heading = productPageContainer.querySelector('.productPage__heading');

            var headingId = 'heading-' + (index + 1);
            heading.setAttribute('id', headingId);

            var sidebarLink = document.createElement('a');
            sidebarLink.classList.add('productPage__sidebarLink');
            sidebarLink.href = '#' + headingId;

            var sidebarHeading = document.createElement('div');
            sidebarHeading.classList.add('productPage__sidebarHeading');

            // Create icon (if present) and include it
            var icon = productPageContainer.querySelector('.productPage__icon');
            if (icon) {
                var sidebarIcon = document.createElement('div');
                sidebarIcon.classList.add('productPage__icon', '-sidebar');
                sidebarIcon.innerHTML = icon.innerHTML; // Copy the icon content
                sidebarHeading.appendChild(sidebarIcon);
            }

            var title = productPageContainer.querySelector('.productPage__headingTitle');
            if (title) {
                var sidebarTitle = document.createElement('div');
                sidebarTitle.classList.add('productPage__sidebarTitle');
                sidebarTitle.innerText = title.innerText;
                sidebarHeading.appendChild(sidebarTitle);
            }

            sidebarLink.appendChild(sidebarHeading);

            // Add description if available
            // Optionally get the description (if it exists) and create a new sidebar description
            var description = productPageContainer.querySelector('.productPage__headingDescription');
            if (description) {
                var sidebarDescription = document.createElement('div');
                sidebarDescription.classList.add('productPage__sidebarDescription');
                
                // Create a new span with class productPage__sidebarDescriptionText and copy the description text into it
                var descriptionText = document.createElement('span');
                descriptionText.classList.add('productPage__sidebarDescriptionText');
                descriptionText.innerText = description.innerText; // Copy the text content
                
                // Append the span inside the sidebar description
                sidebarDescription.appendChild(descriptionText);
                sidebarLink.appendChild(sidebarDescription);
            }
            
            // Add sidebar link to the array for tracking later
            sidebarLinks.push(sidebarLink);

            // Smooth scrolling when a sidebar link is clicked
            sidebarLink.addEventListener('click', function(event) {
                event.preventDefault();

                isManualScroll = true; // Prevent observer-triggered active state during smooth scrolling

                // Determine if the sidebar is expanded or collapsed
                const isSidebarExpanded = sidebarInner.classList.contains('-expanded');
                
                // Calculate the sidebar height based on its state for mobile
                const collapsedSidebarHeight = sidebar.offsetHeight;
                const expandedSidebarHeight = isSidebarExpanded ? sidebarInner.offsetHeight : 0;

                // Calculate the target position after ensuring the layout is settled
                const targetPosition = productPageContainer.getBoundingClientRect().top + window.scrollY;

                // Calculate offsets for sticky navigation and sidebar
                const navOffset = siteHeader ? siteHeader.offsetHeight : 0;
                let scrollOffset;

                if (window.innerWidth >= 1024) {
                    // For desktop, add an 8rem (128px) gap below the fixed nav
                    scrollOffset = navOffset + (4 * 16); // 4rem converted to pixels
                } else {
                    // For mobile, apply dynamic offset based on sidebar state
                    scrollOffset = navOffset + (isSidebarExpanded ? expandedSidebarHeight : collapsedSidebarHeight);
                }

                // Perform smooth scrolling with the calculated offset
                window.scrollTo({
                    top: targetPosition - scrollOffset,
                    behavior: 'smooth'
                });

                // Set active class manually when clicked
                sidebarLinks.forEach(function(link) {
                    link.classList.remove('-active');
                });
                sidebarLink.classList.add('-active');

                // Disable manual scroll flag after smooth scroll
                setTimeout(() => {
                    isManualScroll = false;
                }, 500);

                // Collapse the mobile menu after clicking
                closeSidebarMenu();
            });
            sidebarInner.appendChild(sidebarLink);
        });

        sidebar.appendChild(sidebarInner);
        var productPageMain = productPageContent.querySelector('.productPage__main');
        if (productPageMain) {
            productPageContent.insertBefore(sidebar, productPageMain);
        }

        // Set the first link as active on page load
        if (sidebarLinks.length > 0) {
            sidebarLinks[0].classList.add('-active');
        }

        document.addEventListener('DOMContentLoaded', () => {
            const remainingContent = document.querySelector('.remaining-content');
            if (remainingContent) {
                remainingContent.style.width = '100%'; // Ensure full-width for remaining content
            }
        });

		// Intersection Observer to set active class based on scroll
		var observerOptions = {
		    root: null,
		    threshold: 0.1, // Lower the threshold for earlier detection
		    rootMargin: "0px 0px -40% 0px" // Trigger when the container is 40% below the viewport
		};

		var observer = new IntersectionObserver(function(entries) {
		    if (isManualScroll) return; // Skip observer during manual scroll

		    entries.forEach(function(entry) {
		        var targetId = entry.target.querySelector('.productPage__heading').getAttribute('id');
		        var correspondingLink = document.querySelector(`a[href="#${targetId}"]`);
		        
		        if (entry.isIntersecting) {
		            // Remove active class from all links and add to the current one
		            sidebarLinks.forEach(function(link) {
		                link.classList.remove('-active');
		            });
		            correspondingLink.classList.add('-active');
		        }
		    });
		}, observerOptions);


        // Observe each productPage__container to track its position
        productPageContainers.forEach(function(container) {
            observer.observe(container);
        });

        // Toggle sidebar menu for mobile
		function toggleSidebarMenu() {
		    isMenuOpen = !isMenuOpen;
		    if (isMenuOpen) {
		        sidebarInner.classList.add('-expanded');
		        sidebarToggle.classList.add('-open');
		        // Force a reflow to account for the expanded height
		        sidebarInner.offsetHeight;
		    } else {
		        closeSidebarMenu();
		        sidebarToggle.classList.remove('-open');
		    }
		}

        // Close sidebar menu
        function closeSidebarMenu() {
            isMenuOpen = false;
            sidebarInner.classList.remove('-expanded');
            sidebarToggle.classList.remove('-open');
        }

        // Toggle the sidebar menu on click
        sidebarToggle.addEventListener('click', function(event) {
            toggleSidebarMenu();
            event.stopPropagation();
        });

        // Close the sidebar menu when clicking outside
        document.addEventListener('click', function(event) {
            if (isMenuOpen && !sidebarInner.contains(event.target) && !sidebarToggle.contains(event.target)) {
                closeSidebarMenu();
            }
        });

        // Remove mobile styles at 1024px and up
        window.addEventListener('resize', function() {
            if (window.innerWidth >= 1024) {
                closeSidebarMenu();
            }
        });
    }
});

